import IconButton from "@pathwright/ui/src/components/button/IconButton"
import DropdownItem from "@pathwright/ui/src/components/dropdown/DropdownItem"
import DropdownMenu from "@pathwright/ui/src/components/dropdown/DropdownMenu"
import DropdownTrigger from "@pathwright/ui/src/components/dropdown/DropdownTrigger"
import Screensize from "@pathwright/ui/src/components/ui/Screensize"
import PropTypes from "prop-types"
import styled from "styled-components"
import {
  getPathItemAnalyticsUrl,
  getPathItemCompletionsUrl,
  getPathItemLessonScheduleUrl,
  getPathItemNotesUrl,
  getPathItemScheduleUrl
} from "../../utils/urls"
import { useResourceContext } from "../ResourceContext"
import ControlButton from "../ui/ControlButton"
import PathScheduleLabel from "../ui/PathScheduleLabel"

const Row = styled.div`
  z-index: 1;
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  align-items: center;
  html.no-touch div:not(:hover) > & {
    visibility: hidden;
  }
`

const TeachPathItemControls = ({ pathItem, inverted }) => {
  const { resource, group } = useResourceContext()
  const buttonProps = {
    inverted: inverted,
    styleType: "secondary"
  }
  const scheduleProps = {
    label: "Schedule",
    icon: PathScheduleLabel.actionIcon,
    to: (pathItem.type === "lesson"
      ? getPathItemLessonScheduleUrl
      : getPathItemScheduleUrl)(resource.slug, group.id, pathItem.source_id)
  }
  const analyticsProps = {
    label: "Stats",
    icon: "gauge-square",
    to: getPathItemAnalyticsUrl(resource.slug, group.id, pathItem.source_id)
  }
  const reviewProps = {
    label: "Review",
    icon: "inbox",
    to: getPathItemCompletionsUrl(
      resource.slug,
      group.id,
      pathItem.path_id,
      pathItem.source_id,
      "review"
    )
  }
  const notesProps = {
    label: "Notes",
    icon: "note",
    to: getPathItemNotesUrl(resource.slug, group.id, pathItem.source_id),
    count:
      window.App?.getStore?.("note")?.getState?.()?.notes_per_target?.[
        pathItem.source_id
      ]?.notes?.length || undefined
  }
  return (
    <Screensize.Consumer>
      {(screensize) =>
        screensize === "sm" ? (
          <Row>
            <DropdownTrigger
              renderDropdown={() => (
                <DropdownMenu closeOnClick>
                  <DropdownItem {...scheduleProps} />
                  <DropdownItem {...analyticsProps} />
                  <DropdownItem {...reviewProps} />
                  <DropdownItem {...notesProps} />
                </DropdownMenu>
              )}
            >
              <IconButton
                {...buttonProps}
                styleType="blank"
                icon="ellipses-horizontal"
              />
            </DropdownTrigger>
          </Row>
        ) : (
          <Row>
            <ControlButton {...buttonProps} {...scheduleProps}>
              <PathScheduleLabel
                pathItem={pathItem}
                mode={PathScheduleLabel.modes.actionable}
              />
            </ControlButton>
            <ControlButton {...buttonProps} {...analyticsProps} />
            <ControlButton {...buttonProps} {...reviewProps} />
            <ControlButton {...buttonProps} {...notesProps} />
          </Row>
        )
      }
    </Screensize.Consumer>
  )
}

TeachPathItemControls.displayName = "TeachPathItemControls"

TeachPathItemControls.propTypes = {
  pathItem: PropTypes.object.isRequired,
  inverted: PropTypes.bool
}

export default TeachPathItemControls
